<app-mixit-x509-banner/>
@if (alarm$ | async) {
  <app-alarm-bar [alarm]="alarm$"> </app-alarm-bar>
}

@if (manualForcedOpeningEnabled$ | async) {
  <gbc-banner type="info" [class]="'mt-4'">
    <img src="./assets/svgs/valve.svg" />
    <div>{{ 'mixit-premium-dashboard.manual-forced-opening-warning' | translate }}</div>
  </gbc-banner>
}

@if (showLimitersBanner$ | async) {
  <gbc-banner type="info" [class]="'mt-4'">
    <img src="./assets/svgs/limiter-icon.svg" />
    <div>{{ 'mixit-premium-dashboard.balancing-limiters-active' | translate }}</div>
  </gbc-banner>
}

@if (trialRunningMessage$ | async) {
  <gbc-banner type="info" [class]="'mt-4'">
    <div>{{ trialRunningMessage$ | async }}</div>
    <button gbc-button>{{ 'mixit-premium-dashboard.upgrade-now' | translate }}</button>
  </gbc-banner>
}

@if ((installationCommissionState$ | async) === 'Error') {
  <gbc-banner type="warning" class="mt-8">
    <img src="./assets/svgs/warning.svg" />
    <div [innerHtml]="'mixit-device-states.error-for-device-to-connect' | translate"></div>
  </gbc-banner>
}

@if (isLessThanHalfHourSinceClaim$ | async) {
  <gbc-banner type="info" class="mt-8">
    <div [innerHtml]="'mixit-device-states.waiting-for-device-to-connect' | translate"></div>
  </gbc-banner>
}

<app-schematics-tile
  height="500"
  [applicationId]="(application$ | async)?.id"
  [installationId]="(installation$ | async)?.id"
  [dataPoints$]="dataPoints$"
  [commissionState]="installationCommissionState$ | async"
  [showShadow]="false"
  >
</app-schematics-tile>

<div class="tile-grid">
  <app-mixit-tile [installation$]="installation$" [schematic$]="schematic$" [dataPoints$]="dataPoints$" [application$]="application$">
  </app-mixit-tile>

  @if (showPumpTile$ | async) {
    <app-pump-tile
      class="large-tile"
      [installation$]="installation$"
      [schematic$]="schematic$"
      [dataPoints$]="dataPoints$"
      [application$]="application$"
      >
    </app-pump-tile>
  }

  <app-mixit-temperature-tile
    [installation$]="installation$"
    [schematic$]="schematic$"
    [dataPoints$]="dataPoints$"
    [application$]="application$"
    >
  </app-mixit-temperature-tile>

  @if (isDynamic$ | async) {
    <app-limiters-tile
      [installation$]="installation$"
      [schematic$]="schematic$"
      [dataPoints$]="dataPoints$"
      [application$]="application$"
    ></app-limiters-tile>
  }

  @if (isDynamic$ | async) {
    <app-energy-monitoring-tile
      [installation$]="installation$"
      [schematic$]="schematic$"
      [dataPoints$]="dataPoints$"
      [application$]="application$"
    ></app-energy-monitoring-tile>
  }

  @if (showHeatCoilProtectionTile$ | async) {
    <app-heat-coil-protection-tile
      [installation$]="installation$"
      [schematic$]="schematic$"
      [dataPoints$]="dataPoints$"
      [application$]="application$"
    ></app-heat-coil-protection-tile>
  }

  @if (showWeatherCurve$ | async) {
    <app-mixit-warm-weather-shutdown-tile
      [installation$]="installation$"
      [schematic$]="schematic$"
      [dataPoints$]="dataPoints$"
      [application$]="application$"
    ></app-mixit-warm-weather-shutdown-tile>
  }

  @if (showUnderfloorProtection$ | async) {
    <app-underfloor-protection-tile
      [installation$]="installation$"
      [schematic$]="schematic$"
      [dataPoints$]="dataPoints$"
      [application$]="application$"
    ></app-underfloor-protection-tile>
  }
</div>

@if (application$ | async; as application) {
  @if (showWeatherCurve$ | async) {
    <app-mixit-weather-curve-tile
      [data$]="weatherCurve$"
      [outdoorTemp$]="outdoorTemp$"
      (saveNewCurve)="saveNewCurve($event)"
    ></app-mixit-weather-curve-tile>
  }
  <app-mixit-temperatures-chart
    [title]="'mixit-premium-dashboard.temperature-trend-data' | translate"
    [dataPoints$]="dataPoints$"
    [applicationId]="application.id"
    [userTrackingPeriodOptions]="{ category: 'mixitPremiumDashboard', intervalPrefix: 'temperatureTrendData' }"
    >
  </app-mixit-temperatures-chart>
  <app-mixit-pump-chart
    [dataPoints$]="dataPoints$"
    [application]="application"
    [userTrackingPeriodOptions]="{ category: 'mixitPremiumDashboard', intervalPrefix: 'pumpTrendData' }"
    >
  </app-mixit-pump-chart>
  <app-mixit-flow-valve-chart
    [title]="'mixit-premium-dashboard.flow-trend-data' | translate"
    [dataPoints$]="dataPoints$"
    [installationId]="(installation$ | async)?.id"
    [applicationId]="application.id"
    [userTrackingPeriodOptions]="{ category: 'mixitPremiumDashboard', intervalPrefix: 'flowTrendData' }"
    >
  </app-mixit-flow-valve-chart>
  @if (isDynamic$ | async) {
    <app-mixit-thermal-power-chart
      [dataPoints$]="dataPoints$"
      [installationId]="(installation$ | async)?.id"
      [applicationId]="application.id"
      [userTrackingPeriodOptions]="{ category: 'mixitPremiumDashboard', intervalPrefix: 'thermalPower' }"
      >
    </app-mixit-thermal-power-chart>
  }
}

<app-installation-system-status
  (alarmClick)="navigateToAlarm($event)"
  (showAllAlarms)="navigateToAllAlarms()"
></app-installation-system-status>
